import React from 'react'

/**
 * Panel lateral para mostrar medidas guardadas (solo lectura, informativo)
 * Similar a PanelMedidas pero sin inputs ni botones
 */
const PanelMedidasInfo = ({
  coordenadasCotas,
  medidasCotas,
}) => {
  return (
    <div style={{ 
      border: '1px solid #d9d9d9', 
      borderRadius: '4px', 
      padding: '16px',
      maxHeight: '500px',
      overflowY: 'auto'
    }}>
      <h3 style={{ marginBottom: '16px', fontSize: '16px', fontWeight: 600 }}>
        Medidas
      </h3>
      
      {(coordenadasCotas.length > 0 || medidasCotas.length > 0) ? (
        <>
          {coordenadasCotas.map((cota, index) => {
            const medida = medidasCotas[index]
            const valorMedida = medida?.valor || ''
            const unidadLetra = cota.medida || medida?.medida || 'M'
            let unidadMedidaCota = 'mm'
            if (unidadLetra === 'C') {
              unidadMedidaCota = 'cm'
            } else if (unidadLetra === 'M') {
              unidadMedidaCota = 'mm'
            }
            
            // Extraer letra del label
            let letraLabel = ''
            if (cota.titulo) {
              const match = cota.titulo.match(/^([A-Z])/)
              if (match) {
                letraLabel = match[1]
              } else {
                letraLabel = cota.titulo.charAt(0).toUpperCase()
              }
            }
            
            const lineasReferencia = cota.lineas_a_repuesto && Array.isArray(cota.lineas_a_repuesto) 
              ? cota.lineas_a_repuesto 
              : []
            
            return (
              <div 
                key={`cota-${cota.medida || index}-${cota.nombre || ''}`}
                data-medida-index={index}
                style={{ 
                  marginBottom: '16px',
                  padding: '16px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                  backgroundColor: '#fafafa',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}
              >
                {/* Header de la card */}
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ marginBottom: '8px' }}>
                    <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '4px' }}>
                      {cota.titulo || `Medida ${letraLabel || index + 1}`}
                    </div>
                    {cota.nombre && (
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                        {cota.nombre}
                      </div>
                    )}
                  </div>
                  {cota.referencia_manual && (
                    <div style={{ 
                      fontSize: '11px', 
                      color: '#999', 
                      marginTop: '2px',
                      fontStyle: 'italic'
                    }}>
                      {cota.referencia_manual.etiqueta_estandar}: {cota.referencia_manual.definicion}
                    </div>
                  )}
                </div>

                {/* Valor de la medida */}
                <div style={{ 
                  marginBottom: '12px',
                  padding: '8px',
                  backgroundColor: '#fff',
                  borderRadius: '4px',
                  border: '1px solid #e8e8e8'
                }}>
                  <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                    Valor:
                  </div>
                  <div style={{ fontSize: '16px', fontWeight: 600 }}>
                    {valorMedida} {unidadMedidaCota}
                  </div>
                </div>

                {/* Sección de líneas de referencia */}
                {lineasReferencia.length > 0 && (
                  <div style={{ 
                    marginBottom: '12px',
                    padding: '12px',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                    border: '1px solid #e8e8e8'
                  }}>
                    <div style={{ 
                      fontSize: '13px', 
                      fontWeight: 600,
                      color: '#666',
                      marginBottom: '8px'
                    }}>
                      Líneas de Referencia ({lineasReferencia.length})
                    </div>
                    
                    {lineasReferencia.map((linea, lineaIndex) => {
                      const etiquetaLinea = linea.etiqueta_estandar || linea.label || `Línea ${lineaIndex + 1}`
                      const definicionLinea = linea.definicion || linea.descripcion || 'Línea de referencia'
                      
                      return (
                        <div 
                          key={`linea-${index}-${lineaIndex}`}
                          style={{
                            padding: '8px',
                            marginBottom: lineaIndex < lineasReferencia.length - 1 ? '8px' : '0',
                            backgroundColor: '#f9f9f9',
                            borderRadius: '4px',
                            border: '1px solid #f0f0f0'
                          }}
                        >
                          <div style={{ 
                            fontSize: '12px', 
                            fontWeight: 500,
                            color: '#333',
                            marginBottom: '2px'
                          }}>
                            {etiquetaLinea}: {definicionLinea}
                          </div>
                          <div style={{ 
                            fontSize: '10px', 
                            color: '#999',
                            fontStyle: 'italic'
                          }}>
                            ({linea.x_ini?.toFixed(1) || 0}, {linea.y_ini?.toFixed(1) || 0}) → ({linea.x_fin?.toFixed(1) || 0}, {linea.y_fin?.toFixed(1) || 0})
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            )
          })}
        </>
      ) : (
        <div style={{ color: '#999', textAlign: 'center', padding: '20px' }}>
          No hay medidas disponibles
        </div>
      )}
    </div>
  )
}

export default PanelMedidasInfo
